import React, { useState } from 'react'
import { service } from '../../../../_services/conversation.service'
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../../_actions/alert.actions';
import { OverlayTrigger, Popover } from 'react-bootstrap'

export default function FollowAction({ conversationId }) {
  const dispatch = useDispatch();
  const [following, setFollowing] = useState(false);

  const handleFollow = () => {
    setFollowing(true);
    service.followConversation(conversationId)
      .catch(() => {
        dispatch(alertActions.error('Could not follow this conversation at this time. Please try again later.'));
        setFollowing(false);
      });
  }

  return (
    <OverlayTrigger
      placement='top'
      overlay={
        <Popover>
          <Popover.Content>
            By following this conversation, you'll start receiving new message notifications
          </Popover.Content>
        </Popover>
      }
    >
      <button
        style={{ borderRadius: '16px', fontSize: '12px', width: '14em' }}
        disabled={following}
        onClick={handleFollow}
        className='btn btn-outline-success'
      >
        {following ?
          <i className="fa fa-spinner fa-spin fa-fw"></i>
          :
          <><i className="fas fa-walking"></i> &nbsp; Follow Conversation</>
        }
      </button>
    </OverlayTrigger>
  )
}
